import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="py-16 text-center">
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <p className="mt-2 text-neutral-600 dark:text-neutral-400">Nothing lives at this address.</p>
      <Link to="/" className="mt-4 inline-block text-accent-strong underline dark:text-accent-bright">Back to Focus</Link>
    </div>
  );
}
